import React from 'react'
import ItemButton from '../components/ItemButton'
import ReceiptItem from '../freeformat/components/ReceiptItem'
import OpenOrdersOverview from '../freeformat/components/OpenOrdersOverview'
import { connect } from 'react-redux'
import Receipt from '../components/Receipt'
import Keyboard from '../components/Keyboard'
import Menu from '../components/Menu'
import TitleBar from '../components/TitleBar'
import FunctionBar from '../components/FunctionBar'
import PropTypes from 'prop-types'
import { hashHistory } from 'react-router'
import * as types from '../constants/Types'
import TicketScannerButton from '../freeformat/components/TicketScannerButton'
import SelectPagerButton from '../freeformat/components/SelectPagerButton'
import ArticlePrice from '../freeformat/components/ArticlePrice'

class OverviewPage extends React.Component {
  componentDidMount() {
    if (!this.props.userId || this.props.userId <= 0) {
      hashHistory.push("/login");
    }
    else if (this.props.posType === types.POSTYPE_ORDERKIOSK || this.props.posType === types.POSTYPE_SALESKIOSK) {
      hashHistory.push("/kiosk");
    }
    else if (this.props.posType === types.POSTYPE_CHARGINGKIOSK) {
      hashHistory.push("/chargingkiosk");
    }
    else if (this.props.posType === types.POSTYPE_TICKETSCANNER) {
      hashHistory.push("/ticketscanner");
    }
    else if (this.props.posType === types.POSTYPE_PRODUCTIONKIOSK) {
      hashHistory.push("/production");
    }
  }


  render() {
    let rasterx = 6
    let rastery = 6
    let keys = [];
    for (let i = 0; i < this.props.groups.length; i++) {
      if (this.props.groups[i].KeyLayoutGroupId === this.props.groupId) {
        const item = this.props.groups[i]
        rasterx = item.RasterX
        rastery = item.RasterY
        keys = item.KeyLayoutItems
      }
    }

    const datagrid = {
      x: rasterx,
      y: rastery
    }

    const defaultbtnwidth = 100.0 / datagrid.x
    const defaultbtnheight = 100.0 / datagrid.y

    const drawbtns = []
    keys.map(key => {
      const btnwidth = defaultbtnwidth * key.Width
      const btnheight = defaultbtnheight * key.Height

      const btntop = (defaultbtnheight * (key.LocationY + 1)) - defaultbtnheight
      const btnleft = (defaultbtnwidth * (key.LocationX + 1)) - defaultbtnwidth

      drawbtns.push({
        id: key.KeyLayoutItemId,
        itemvalue: key.ItemValue,
        itemtype: key.ItemType,
        itemparam: key.ItemParam,
        shouldBlink: key.ShouldBlink,
        description: key.Description,
        color: key.Color,
        width: btnwidth,
        height: btnheight,
        top: btntop,
        left: btnleft,
        fileAttachmentId: key.FileAttachmentId,
        opacity: key.Opacity
      })
      return ''
    });

    return (
      <div id="app">
        <div id="main-container">
          <TitleBar />
          <div id="overview">
            <div id="items">
              {
                drawbtns.map(btn => {
                  switch (btn.itemtype) {
                    case types.BUTTON_OTHER:
                      return <ReceiptItem
                        key={btn.id}
                        id={btn.id}
                        width={btn.width}
                        height={btn.height}
                        top={btn.top}
                        left={btn.left}
                        itemvalue={btn.itemvalue}
                      />
                    case types.BUTTON_FUNCTION:
                      switch (btn.itemvalue) {
                        case '310':
                          return <OpenOrdersOverview
                            key={btn.id}
                            id={btn.id}
                            width={btn.width}
                            height={btn.height}
                            top={btn.top}
                            left={btn.left}
                            itemvalue={btn.itemvalue}
                            itemparam={btn.itemparam}
                          />
                        case '320':
                          return <TicketScannerButton
                            key={btn.id}
                            id={btn.id}
                            width={btn.width}
                            height={btn.height}
                            top={btn.top}
                            left={btn.left}
                          />
                        case '370':
                          return <SelectPagerButton
                            key={btn.id}
                            id={btn.id}
                            width={btn.width}
                            height={btn.height}
                            top={btn.top}
                            left={btn.left}
                          />
                        case '380':
                          return <ArticlePrice
                            key={btn.id}
                            width={btn.width}
                            height={btn.height}
                            top={btn.top}
                            left={btn.left}
                            itemparam={btn.itemparam}
                            fileAttachmentId={btn.fileAttachmentId}
                          />
                        default:
                          return <ItemButton
                            key={btn.id}
                            id={btn.id}
                            itemvalue={btn.itemvalue}
                            itemtype={btn.itemtype}
                            itemparam={btn.itemparam}
                            text={btn.description}
                            color={btn.color}
                            btnwidth={btn.width}
                            btnheight={btn.height}
                            btntop={btn.top}
                            btnleft={btn.left}
                            price={btn.price}
                            configurationsteps={btn.configurationsteps}
                            invisible={btn.invisible}
                            fileAttachmentId={btn.fileAttachmentId}
                          />
                      }
                    default:
                      return <ItemButton
                        key={btn.id}
                        id={btn.id}
                        itemvalue={btn.itemvalue}
                        itemtype={btn.itemtype}
                        itemparam={btn.itemparam}
                        shouldBlink={btn.shouldBlink}
                        opacity={btn.opacity}
                        text={btn.description}
                        color={btn.color}
                        btnwidth={btn.width}
                        btnheight={btn.height}
                        btntop={btn.top}
                        btnleft={btn.left}
                        price={btn.price}
                        configurationsteps={btn.configurationsteps}
                        invisible={btn.invisible}
                        fileAttachmentId={btn.fileAttachmentId}
                      />
                  }
                })}
            </div>
          </div>
          <Menu />
          <FunctionBar cssClass="ov_functionbar" />
        </div>
        <div id="receipt-keyboard-container">
          <Receipt />
          <Keyboard />
        </div>
      </div>
    )
  }
}

OverviewPage.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    KeyLayoutGroupId: PropTypes.number.isRequired
  })).isRequired,
  groupId: PropTypes.number.isRequired
}

function mapStateToProps(state) {
  return {
    groups: state.layoutState.groups.items,
    groupId: state.layoutState.groupid,
    isLoading: state.generalState.isLoading,
    posType: state.generalState.posType,
    userId: state.loginState.loggedin.id
  }
}

export default connect(mapStateToProps)(OverviewPage)



// WEBPACK FOOTER //
// src/pages/OverviewPage.jsx